import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          // Navigation
          "navigation.home": "Home",
          "navigation.teachers": "Teachers",
          "navigation.discord": "Community",
          
          // Hero Section
          "hero.title": "Study Smarter, and Harder!",
          "hero.subtitle": "AI-powered HKDSE exercises and mock exam papers with AI marking and personalized feedback for students and teachers.",
          "hero.getStarted": "Get Started",
          "hero.joinDiscord": "Join Our Online Discord Community",
          
          // Buttons
          "buttons.generate": "Generate",
          "buttons.submit": "Submit",
          "buttons.next": "Next",
          "buttons.retry": "Retry",
          "buttons.generateNew": "Generate New",
          
          // Labels
          "labels.questionType": "Question Type",
          "labels.difficulty": "Difficulty",
          "labels.topic": "Topic",
          "labels.progress": "Progress",
          "labels.readingPassage": "Reading Passage",
          "labels.questions": "Questions",
          "labels.enterAnswer": "Enter your answer",
          "labels.markingResults": "Marking Results",
          "labels.correct": "Correct",
          "labels.incorrect": "Incorrect",
          "labels.feedback": "Feedback",
          "labels.practiceMode": "Question-Answer book: Practice Mode",
          
          // CEPT Specific
          "cept.readingComprehension": "Reading Comprehension",
          "cept.vocabularyGrammar": "Vocabulary & Grammar",
          "cept.generateCEPT": "Generate CEPT Practice",
          "cept.welcome": "Welcome to CEPT Practice!",
          "cept.description": "Practice Cambridge English Placement Test (CEPT) with AI-generated exercises and instant feedback.",
          "cept.generatePaper": "Cambridge CEPT Practice Test",
          
          // HKDSE Specific
          "hkdse.welcome": "Welcome to PaperTips!",
          "hkdse.description": "AI-powered HKDSE English mock exam papers with intelligent marking and personalized feedback.",
          "hkdse.welcomeDescription": "Ready to boost your HKDSE performance?",
          "hkdse.generatePaper": "Generate HKDSE English Mock Exam Paper",
          
          // Discord
          "discord.invitation.title": "🎉 Great job completing the practice!",
          "discord.invitation.description": "Join our Online Discord Community to discuss answers, get help, and connect with other students!",
          "discord.invitation.button": "Join Our Online Discord Community",
          
          // Loading
          "loading.generatingCEPT": "Generating your CEPT practice materials...",
          "loading.generatingHKDSE": "Generating your exercises and mock exam paper...",
          
          // Errors
          "errors.noContent": "No content available",
          "errors.generateNewContent": "Please generate new content or try again.",
          
          // Marking
          "marking.title": "🤖 AI is marking your answers...",
          "marking.description": "Please wait while our AI analyzes your responses and provides detailed feedback.",
          "marking.analyzing": "Analyzing grammar, comprehension, and providing personalized feedback...",
          "marking.status": "🤖 AI Service Status",
          "marking.attempt": "Attempt {retryCount} of {maxRetries}",
          "marking.inProgress": "Marking...",
          
          // Placeholders
          "placeholders.topic": "e.g., Technology, Environment, Education, Business...",

          // PreferencesForm (new)
          "pref.topicOfDay.title": "🎯 Topic of the Day",
          "pref.topicOfDay.cardTitle": "Daily Topic Ready",
          "pref.topicOfDay.subtitle": "A fresh topic generated just for you",
          "pref.topicOfDay.button": "Use Today's Topic",
          "pref.topicOfDay.hint": "Fresh topic generated daily at 6:00 AM (UTC+8)",
          "pref.topicOfDay.displayLabel": "Topic of the Day",
          "pref.chooseFromTopics": "Choose from Topics",
          "pref.topics.hint": "Click on any topic card to select it for your practice",
          "pref.customTopic": "Custom Topic",
          "pref.custom.placeholder": "Enter specific topic (e.g., Environmental Protection)",
          "pref.custom.hint": "Leave blank for general topic",
          "pref.selected.label": "Selected:",
          "pref.generate": "Generate!"
        }
      },
      'zh-TW': {
        translation: {
          // Navigation
          "navigation.home": "首頁",
          "navigation.teachers": "教師專區",
          "navigation.discord": "社群",
          
          // Hero Section
          "hero.title": "善用AI，贏在起跑線！",
          "hero.subtitle": "AI 驅動的 HKDSE 練習和模擬試卷，配備 AI 批改和個人化回饋，專為學生和教師設計。",
          "hero.getStarted": "開始使用",
          "hero.joinDiscord": "加入 Discord 社群",
          
          // Buttons
          "buttons.generate": "生成",
          "buttons.submit": "提交",
          "buttons.next": "下一題",
          "buttons.retry": "重試",
          "buttons.generateNew": "整份新的練習",
          
          // Labels
          "labels.questionType": "題目類型",
          "labels.difficulty": "難度",
          "labels.topic": "主題",
          "labels.progress": "進度",
          "labels.readingPassage": "閱讀文章",
          "labels.questions": "問題",
          "labels.enterAnswer": "輸入你的答案",
          "labels.markingResults": "評分結果",
          "labels.correct": "正確",
          "labels.incorrect": "錯誤",
          "labels.feedback": "回饋",
          "labels.practiceMode": "題目與答案書：練習模式",
          
          // CEPT Specific
          "cept.readingComprehension": "閱讀理解",
          "cept.vocabularyGrammar": "詞彙與文法",
          "cept.generateCEPT": "生成 CEPT 練習",
          "cept.welcome": "歡迎來到 CEPT 練習！",
          "cept.description": "練習劍橋英語分級測試 (CEPT)，配備 AI 生成的練習題和即時回饋。",
          "cept.generatePaper": "劍橋 CEPT 練習測驗",
          
          // HKDSE Specific
          "hkdse.welcome": "歡迎來到 PaperTips！",
          "hkdse.description": "AI 驅動的 HKDSE 英語模擬試卷，配備智能評分和個人化回饋。",
          "hkdse.welcomeDescription": "準備好提升你的 HKDSE 表現了嗎？",
          "hkdse.generatePaper": "生成 HKDSE 英語模擬試卷",
          
          // Discord
          "discord.invitation.title": "🎉 恭喜完成練習！",
          "discord.invitation.description": "加入我們的線上 Discord 社群，討論答案、獲得幫助，並與其他學生交流！",
          "discord.invitation.button": "加入我們的線上 Discord 社群",
          
          // Loading
          "loading.generatingCEPT": "正在生成您的 CEPT 練習材料...",
          "loading.generatingHKDSE": "正在生成您的練習題和模擬試卷...",
          
          // Errors
          "errors.noContent": "無內容可顯示",
          "errors.generateNewContent": "請生成新的內容或重試。",
          
          // Marking
          "marking.title": "🤖 AI 正在為您的答案評分中...",
          "marking.description": "請稍候，AI 正在分析您的回應並提供詳細的回饋。",
          "marking.analyzing": "正在分析文法、理解力和提供個人化回饋...",
          "marking.status": "🤖 AI 服務狀態",
          "marking.attempt": "嘗試 {retryCount} 次，共 {maxRetries} 次",
          "marking.inProgress": "評分中...",
          
          // Placeholders
          "placeholders.topic": "例如：科技、環境、教育、商業...",

          // PreferencesForm (new)
          "pref.topicOfDay.title": "🎯 今日主題",
          "pref.topicOfDay.cardTitle": "今日主題已準備好",
          "pref.topicOfDay.subtitle": "為你度身訂做嘅新主題",
          "pref.topicOfDay.button": "用今日嘅主題",
          "pref.topicOfDay.hint": "每日早上 6:00（UTC+8）自動更新",
          "pref.topicOfDay.displayLabel": "今日主題",
          "pref.chooseFromTopics": "由主題清單揀選",
          "pref.topics.hint": "按任意主題卡即可選擇",
          "pref.customTopic": "自訂主題",
          "pref.custom.placeholder": "輸入具體主題（例如：環境保護）",
          "pref.custom.hint": "留空會用一般主題",
          "pref.selected.label": "已選擇：",
          "pref.generate": "生成！"
        }
      }
    },
    fallbackLng: 'en', // Default to English
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'localStorage', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupSessionStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      caches: ['localStorage', 'sessionStorage'],
      excludeCacheFor: ['cimode'],
      cookieExpirationDate: new Date(),
      cookieSecure: false,
      cookieDomain: 'myDomain',
      cookiePath: '/myPath',
      htmlTag: document.documentElement,
      convertDetectedLanguage: (lng) => {
        // Convert various Chinese language codes to zh-TW
        if (lng && (lng.startsWith('zh') || lng.startsWith('cmn') || lng.startsWith('yue'))) {
          return 'zh-TW';
        }
        return lng;
      }
    }
  });

export default i18n; 